import { useTheme } from '@mui/material';

import { useFeatureFlagSplit } from '@verantos-dev/core-utils';

import { useAdminCardsSection } from './components/useAdminCardsSection';
import { useAnnotationCardsSection } from './components/useAnnotationCardsSection';

export const useDashboard = () => {
  const theme = useTheme();

  // TODO: cleanup with cp_annotation_show_dashboard_loading_spinner ff
  const showLoadingSpinner = useFeatureFlagSplit(
    'cp_annotation_show_dashboard_loading_spinner'
  ) as boolean;

  const {
    isAssignmentCountLoading,
    isBatchReviewCountLoading,
    isProjectsCountLoading,
    isHasAnnotationTasksLoading,
    isHasSupervisionBatchesLoading,
  } = useAnnotationCardsSection();
  const { isTotalProjectsCountLoading } = useAdminCardsSection();

  const isDashboardLoading =
    isAssignmentCountLoading ||
    isBatchReviewCountLoading ||
    isProjectsCountLoading ||
    isHasAnnotationTasksLoading ||
    isHasSupervisionBatchesLoading ||
    isTotalProjectsCountLoading;

  return {
    theme,
    showLoadingSpinner,
    isDashboardLoading,
  };
};
